module.exports = __webpack_public_path__ + "img/trash.53839052.svg";